import { useRef, useState } from 'react';

import { ValidationCreditCardType } from './use-credit-card-validation';

interface HyperPayConfigModel {
  hyperPayUrl: string;
  hyperPayCheckId: string;
  creditCardNumber: string;
  creditCardCvv: string;
  creditCardHolder: string;
  creditCardType: ValidationCreditCardType;
  expiryMonth: string;
  expiryYear: string;
  errorCallback?: () => void;
}

export const useHyperPayTokenization = () => {
  const [isHyperPayLoading, setIsHyperPayLoading] = useState(false);

  const { current: hyperPayTokenizationController } = useRef<AbortController>(
    new AbortController()
  );

  const hyperPayTokenization = async (config: HyperPayConfigModel) => {
    const {
      hyperPayUrl,
      hyperPayCheckId,
      creditCardNumber,
      creditCardCvv,
      creditCardHolder,
      creditCardType,
      expiryMonth,
      expiryYear,
      errorCallback,
    } = config;

    try {
      const myHeaders = new Headers();
      myHeaders.append('Content-Type', 'application/x-www-form-urlencoded');

      const urlencoded = new URLSearchParams();
      urlencoded.append(
        'paymentBrand',
        creditCardType === 'visa'
          ? 'VISA'
          : creditCardType === 'mastercard'
          ? 'MASTER'
          : creditCardType === 'american-express'
          ? 'AMEX'
          : ''
      );
      urlencoded.append('card.number', creditCardNumber);
      urlencoded.append('card.cvv', creditCardCvv);
      urlencoded.append('card.expiryMonth', expiryMonth);
      urlencoded.append('card.expiryYear', expiryYear);
      urlencoded.append('card.holder', creditCardHolder);

      const requestOptions: RequestInit = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow',
        signal: hyperPayTokenizationController.signal,
      };

      setIsHyperPayLoading(true);

      await fetch(`${hyperPayUrl}/${hyperPayCheckId}/registration`, requestOptions);
      return hyperPayCheckId;
    } catch (error) {
      errorCallback?.();
    } finally {
      setIsHyperPayLoading(false);
    }
  };

  return {
    isHyperPayLoading,
    hyperPayTokenizationController,
    hyperPayTokenization,
  };
};
